module.exports = __webpack_public_path__ + "img/retriggerasmnt.8572ef70.svg";